import { render } from "./Enigme6.vue?vue&type=template&id=d154f3be"
import script from "./Enigme6.vue?vue&type=script&lang=js"
export * from "./Enigme6.vue?vue&type=script&lang=js"

import "./Enigme6.vue?vue&type=style&index=0&id=d154f3be&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__